import { defineMessages } from 'react-intl';

export default defineMessages({
    baPolicyInfo: {
        id: 'quoteandbind.views.policyinfo.ba.Personal Auto Policy Information',
        defaultMessage: 'Personal Auto Policy Information',
    },
    baPolicyInformation: {
        id: 'quoteandbind.ba.views.ba-policy-info.Policy Information',
        defaultMessage: 'Policy Information',
    },
    coverageStartDate: {
        id: 'quoteandbind.ba.views.ba-policy-info.Coverage Start Date',
        defaultMessage: 'Coverage Start Date',
    },
    vehicles: {
        id: 'quoteandbind.ba.views.ba-policy-info.Vehicles',
        defaultMessage: 'Vehicles'
    },
    name: {
        id: 'quoteandbind.ba.views.ba-policy-info.Name',
        defaultMessage: 'Name'
    },
    phoneNumber: {
        id: 'quoteandbind.ba.views.ba-policy-info.Phone Number',
        defaultMessage: 'Phone Number'
    },
    emailAddress: {
        id: 'quoteandbind.ba.views.ba-policy-info.Email Address',
        defaultMessage: 'Email Address'
    },
    noDriversExist: {
        id: 'quoteandbind.ba.views.ba-policy-info.No Drivers Exist',
        defaultMessage: 'No Drivers Exist...',
    },
    primaryDriverContactDetails: {
        id: 'quoteandbind.ba.views.ba-policy-info.Primary Driver Contact Details',
        defaultMessage: 'Primary Driver Contact Details',
    },
    drivers: {
        id: 'quoteandbind.ba.views.ba-policy-info.Drivers',
        defaultMessage: 'Drivers',
    },
    displayName: {
        id: 'quoteandbind.ba.views.ba-policy-info.driver.Name',
        defaultMessage: 'Name'
    },
    licenseNumber: {
        id: 'quoteandbind.ba.views.ba-policy-info.driver.License Number',
        defaultMessage: 'License Number'
    },
    driverlicenseState: {
        id: 'quoteandbind.ba.views.ba-policy-info.driver.License State',
        defaultMessage: 'License State'
    },
    make: {
        id: 'quoteandbind.ba.views.ba-policy-info.Make',
        defaultMessage: 'Make',
    },
    noVehiclesExist: {
        id: 'quoteandbind.ba.views.ba-policy-info.No Vehicles Exist',
        defaultMessage: 'No Vehicles Exist...',
    },
    model: {
        id: 'quoteandbind.ba.views.ba-policy-info.Model',
        defaultMessage: 'Model'
    },
    year: {
        id: 'quoteandbind.ba.views.ba-policy-info.Year',
        defaultMessage: 'Year'
    },
    licensePlate: {
        id: 'quoteandbind.ba.views.ba-policy-info.License Plate',
        defaultMessage: 'License Plate'
    },
    vehicleLicenseState: {
        id: 'quoteandbind.ba.views.ba-policy-info.License State',
        defaultMessage: 'License State'
    },
    taxes: {
        id: 'quoteandbind.ba.views.ba-policy-info.Taxes',
        defaultMessage: 'Taxes'
    },
    fees: {
        id: 'quoteandbind.ba.views.ba-policy-info.Fees',
        defaultMessage: 'Fees'
    },
    downloadQuoteSummary:{
       id: 'quoteandbind.common.policy-info.Download Quote Summary',
       defaultMessage: 'Download Quote Summary'
    },
    baDocumentGenerationInProgress:{
       id: 'quoteandbind.ba.policy-info.Document Generation Is In Progress',
       defaultMessage: 'Document Generation Is In Progress'
    },
    baDocumentGenerationInProgressConf:{
       id: 'quoteandbind.ba.policy-info.Document Generation Is In Progress. Please Try After Sometime.',
       defaultMessage: 'Document Generation Is In Progress. Please Try After Sometime.'
    },
    baDocumentGenerationError:{
       id: 'quoteandbind.ba.policy-info.Unable to get quote document',
       defaultMessage: 'Unable to get quote document'
    },
    baDocumentGenerationErrorConf:{
       id: 'quoteandbind.ba.policy-info.Problem occured while getting quote document. Please try again later',
       defaultMessage: 'Problem occured while getting quote document. Please try again later'
    },
    baPolInfoDetails:{
       id: 'quoteandbind.ba.policy-info.Details',
       defaultMessage: 'Details'
    },
    baPolInfoProdCode:{
       id: 'quoteandbind.ba.policy-info.Producer Code',
       defaultMessage: 'Producer Code'
    },
    baPolInfoPolStatus:{
       id: 'quoteandbind.ba.policy-info.Policy Status',
       defaultMessage: 'Policy Status'
    },
    baPolInfoTotalPrem:{
       id: 'quoteandbind.ba.policy-info.Total Premium',
       defaultMessage: 'Total Premium'
    },
    baPolInfoTotalCost:{
       id: 'quoteandbind.ba.policy-info.Total Cost',
       defaultMessage: 'Total Cost'
    },
    baPolInfVino:{
       id: 'quoteandbind.ba.policy-info.VIN',
       defaultMessage: 'VIN'
    },
    baPolInfoVehInfo:{
       id: 'quoteandbind.ba.policy-info.Vehicle Type',
       defaultMessage: 'Vehicle Type'
    },
    baPolInfoEffDate:{
       id: 'quoteandbind.ba.policy-info.Effective Date',
       defaultMessage: 'Effective Date'
    },
    baPolInfoExpDate:{
       id: 'quoteandbind.ba.policy-information.Expiration Date',
       defaultMessage: 'Expiration Date'
    },
});
